<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <div mat-card-avatar class="header-image"></div>
      <mat-card-title>D2 Armor Picker</mat-card-title>
      <mat-card-subtitle
        >Find the best possible armor combination for your desired stats.</mat-card-subtitle
      >
    </mat-card-header>

    <mat-card-content>
      <div
        class="carousel-container"
        (mouseenter)="pauseCarousel()"
        (mouseleave)="resumeCarousel()">
        <div class="carousel-track" [style.transform]="'translateX(' + -currentSlide * 100 + '%)'">
          <div class="carousel-slide" *ngFor="let item of carouselItems">
            <img [src]="item.image" [alt]="item.title" class="carousel-image" />
            <div class="carousel-caption">
              <h3>{{ item.title }}</h3>
              <p>{{ item.subtitle }}</p>
            </div>
          </div>
        </div>

        <div class="carousel-indicators">
          <button
            *ngFor="let item of carouselItems; let i = index"
            [class.active]="i === currentSlide"
            (click)="goToSlide(i)"
            class="indicator">
          </button>
        </div>
      </div>

      <div class="login-actions">
        <button mat-raised-button color="primary" class="login-button" (click)="startLogin()">
          Sign in with Bungie
        </button>
      </div>

      <div class="login-footer">
        <p class="privacy-link">
          By signing in, you agree to our
          <a routerLink="/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
